export default __webpack_public_path__ + "static/media/usdc_w.4a94dabe.svg";